module.exports = __webpack_public_path__ + "img/81w.95e0ae9.jpg";